import truncate from 'lodash/truncate';

import * as R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { round4 } from 'utilities/math';
import {
  NUMERICALSUMMARY_COLUMNS
} from './columns';

const NumericalSummaryComponent = props => (
  <div
    ref={props.captureContentItemElement}
    className={
      classNames(
        'content-item-auto',
        props.className
      )
    }
  >
    <div className="flex flex-shrink space-between">
      <p className="font-700 mb-5">
        Summary Table
      </p>

      <div>
        <button
          type="button"
          onClick={props.onFullScreenIconClick}
          className="icon icon-fullscreen cursor-pointer font-14 in-blue-500 ml-15"
        />
      </div>
    </div>

    {props.hideParametersTypeLabel ||
      <div className="mb-15">
        <span className="main-checkbox-filter__props bg-grey-200 mr-5">
          <i className="icon icon-1-9" />
        </span>

        <span className="align-middle font-14">
          Numerical Variables
        </span>
      </div>
    }

    <table id="summary-table" data-testid="summary-table" className="main-table">
      <colgroup>
        <col className="bg-grey-150" />
      </colgroup>

      <thead>
        <tr>
          <th>
            Variables
          </th>

          {R.keys(props.selectedColumns).filter(columnName => NUMERICALSUMMARY_COLUMNS[columnName]).map(name => {
            return (
              <th key={name} className="text-right" >
                {NUMERICALSUMMARY_COLUMNS[name]}
              </th>
            );
          })}
        </tr>
      </thead>

      <tbody>
        {R.keys(props.summary).map(property => {
          const values = props.summary[property];
          const columns = props.selectedColumns;
          // Order of columns is important! should match columns.js
          return (
            <tr key={property} id={property}>
              <td className="font-13 font-700">
                {truncate(property, { length: 20 })}
              </td>
              {Object.keys(columns).includes('mean') &&
              <td
                className="text-right" id="mean"
              >
                {round4(values.mean)}
              </td>
              }
              {Object.keys(columns).includes('sampleStandardDeviation') &&
              <td
                className="text-right" id="sampStDev"
              >
                {typeof values.sampleStandardDeviation === 'number' ? round4(values.sampleStandardDeviation) : values.sampleStandardDeviation}
              </td>
              }
              {Object.keys(columns).includes('count') &&
              <td className="text-right" id="count">
                {round4(values.count)}
              </td>
              }
              {Object.keys(columns).includes('sum') &&
              <td className="text-right" id="sum">
                {round4(values.sum)}
              </td>
              }
              {Object.keys(columns).includes('sumOfSquares') &&
              <td
                className="text-right" id="sumOfSquares"
              >
                {round4(values.sumOfSquares)}
              </td>
              }
              {Object.keys(columns).includes('standardDeviation') &&
              <td
                className="text-right" id="stdev"
              >
                {typeof values.standardDeviation === 'number' ? round4(values.standardDeviation) : values.standardDeviation}
              </td>
              }
              {Object.keys(columns).includes('min') &&
              <td
                className="text-right" id="min"
              >
                {round4(values.min)}
              </td>
              }
              {Object.keys(columns).includes('firstQuantile') &&
              <td
                className="text-right" id="first-quantile"
              >
                {round4(values.firstQuantile)}
              </td>
              }
              {Object.keys(columns).includes('median') &&
              <td
                className="text-right" id="median"
              >
                {round4(values.median)}
              </td>
              }

              {Object.keys(columns).includes('thirdQuantile') &&
              <td
                className="text-right" id="third-quantile"
              >
                {round4(values.thirdQuantile)}
              </td>
              }
              {Object.keys(columns).includes('max') &&
              <td
                className="text-right" id="max"
              >
                {round4(values.max)}
              </td>
              }
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

NumericalSummaryComponent.propTypes = {
  className: PropTypes.string,

  selectedColumns: PropTypes.object,
  summary: PropTypes.object.isRequired,
  hideParametersTypeLabel: PropTypes.bool,

  onFullScreenIconClick: PropTypes.func.isRequired,
  captureContentItemElement: PropTypes.func.isRequired
};

NumericalSummaryComponent.defaultProps = {
  hideParametersTypeLabel: false,

  className: null
};

export default NumericalSummaryComponent;
